import * as marietta from '../../marietta';

// import Point = marietta.core.Point;

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
/*------------------------------------------------------
    * SScale  (Coordinate convert classs)
    *
    */
export default class Scale {
        public rate: number;

        public base: marietta.core.Point;

        public ctxWidth: number;

        public ctxHeight: number;

        public module: number;

        public planCenter: marietta.core.Point;

        public WEBCAD_PITCH: number;

        /*------------------------------------------------------
        * constructor
        *
        */
        constructor() {
          this.rate = 0;
          this.base = new marietta.core.Point(0, 0, 0);
          this.ctxWidth = 0;
          this.ctxHeight = 0;
          this.module = 0;
          this.planCenter = new marietta.core.Point(0, 0, 0);
          this.WEBCAD_PITCH = 60;
        }

        /*------------------------------------------------------
        * {get} WEBCAD_PITCH
        *
        */
        public GetModulePitch(): number {
          return this.WEBCAD_PITCH;
        }

        /*------------------------------------------------------
        * {set, get} module
        *
        */
        public SetModule(mod: number) {
          this.module = mod;
        }

        /*------------------------------------------------------
        * setPitch
        *
        */
        public SetPitch(pitch: number) {
          this.WEBCAD_PITCH = pitch;
        }

        public GetModule(): number {
          return this.module;
        }

        /*------------------------------------------------------
        * SScale
        * Canvas --> WebCAD
        */
        public ConvertToWebCAD(p: marietta.core.Point): marietta.core.Point {
          const wp = new marietta.core.Point(0, 0, 0);
          wp.x = (p.x / this.rate + this.base.x);
          wp.y = (this.ctxHeight - p.y) / this.rate + this.base.y;
          return wp;
        }

        /*------------------------------------------------------
        * SScale
        * WebCAD --> Canvas
        */
        public ConvertToCanvas(p: marietta.core.Point): marietta.core.Point {
          const ip = new marietta.core.Point(0, 0, 0);
          ip.x = Math.floor((p.x - this.base.x) * this.rate);
          ip.y = Math.floor(this.ctxHeight - ((p.y - this.base.y) * this.rate));
          return ip;
        }

        /*------------------------------------------------------
        * SScale
        * WebCAD --> 3D Model(Collada)
        */
        public ConvertTo3DModelFromWebCAD(p: marietta.core.Point): marietta.core.Point {
          const ip = new marietta.core.Point(0, 0, 0);
          ip.x = (((p.x - this.planCenter.x) / this.WEBCAD_PITCH) * this.module) / 1000;
          ip.y = (((p.y - this.planCenter.y) / this.WEBCAD_PITCH) * this.module) / 1000;
          return ip;
        }

        /*------------------------------------------------------
        * SScale
        * 3D Model(Collada) --> WebCAD
        */
        public ConvertToWebCADFrom3DModel(p: marietta.core.Point): marietta.core.Point {
          const ip = new marietta.core.Point(0, 0, 0);
          ip.x = ((p.x * 1000) / this.module) * this.WEBCAD_PITCH + this.planCenter.x;
          ip.y = ((p.y * 1000) / this.module) * this.WEBCAD_PITCH + this.planCenter.y;
          return ip;
        }

        /*------------------------------------------------------
        * SScale
        * WebCAD Value --> World Value
        */
        public ConvertCadToWorld(v: number): number {
          return ((v / this.WEBCAD_PITCH) * this.module);
        }

        /*------------------------------------------------------
        * SScale
        * World Value --> WebCAD Value
        */
        public ConvertWorldToCad(v: number): number {
          return ((v / this.module) * this.WEBCAD_PITCH);
        }

        /*------------------------------------------------------
        * SScale
        * Culcration rate, basePoint
        */
        public culc(ctxW: number, ctxH: number, min: marietta.core.Point, max: marietta.core.Point) {
          const h = (max.x - min.x) * 1.6;
          const v = (max.y - min.y) * 1.6;
          const sh = ctxW / h;
          const sv = ctxH / v;
          if (sh < sv) {
            this.rate = sh;
          } else {
            this.rate = sv;
          }
          this.base.x = (max.x - min.x) / 2 - ctxW / this.rate / 2 + min.x;
          this.base.y = (max.y - min.y) / 2 - ctxH / this.rate / 2 + min.y;
          this.ctxWidth = ctxW;
          this.ctxHeight = ctxH;
          this.planCenter.x = (max.x + min.x) / 2;
          this.planCenter.y = (max.y + min.y) / 2;
        }

        /*------------------------------------------------------
        * SScale
        * Offset at SCREEN Coordinate
        */
        public ScreenOffset(down: marietta.core.Point, move: marietta.core.Point) {
          const cadDown = this.ConvertToWebCAD(down);
          const cadMove = this.ConvertToWebCAD(move);
          this.base.x += (cadMove.x - cadDown.x);
          this.base.y += (cadMove.y - cadDown.y);
        }

        /*------------------------------------------------------
        * SScale
        * View scale    sc > 1.0 scale UP
        *               sc < 1.0 scale DOWN
        */
        public SetViewScale(pin: marietta.core.Point, sc: number) {
          const cadPinBefor = this.ConvertToWebCAD(pin);
          this.rate *= sc;
          const cadPinAfter = this.ConvertToWebCAD(pin);
          this.base.x -= (cadPinAfter.x - cadPinBefor.x);
          this.base.y -= (cadPinAfter.y - cadPinBefor.y);
        }

        /*------------------------------------------------------
        * SScale
        * View size
        */
        public SetViewSize(ctxW: number, ctxH: number) {
          const w = (ctxW - this.ctxWidth) / 2;
          const h = (ctxH - this.ctxHeight) / 2;
          const x = -w;
          const y = this.ctxHeight + h;
          const base = this.ConvertToWebCAD(new marietta.core.Point(x, y, 0));
          this.ctxWidth = ctxW;
          this.ctxHeight = ctxH;
          this.base.x = base.x;
          this.base.y = base.y;
        }
}
